import { Stack, useTheme } from "@mui/material";
import { ActionRow, ActionType, RowActions } from "./ActionRow";
import { Loading } from "src/components/utils/Loading";

export type ActionsBlockProps = RowActions & {
    actionBlocks: ActionType[];
    isLoading: boolean;
};
export const ActionsBlock = (props: ActionsBlockProps) => {
    const { actionBlocks, addAction, editAction, deleteAction } = props;
    const theme = useTheme();

    if (props.isLoading) {
        return <Loading />;
    }

    return (
        <Stack padding={theme.spacing(2, 4, 2, 4)} gap={theme.spacing(0.5)}>
            {actionBlocks.map((action) => {
                return (
                    <ActionRow
                        key={`${action.id}-actionBlock-${action.actionTitle}`}
                        {...action}
                        addAction={addAction}
                        editAction={editAction}
                        deleteAction={deleteAction}
                    />
                );
            })}
        </Stack>
    );
};
